// extracted by mini-css-extract-plugin
export default {"spinAround":"CreateSiteForm_spinAround_XT6qG"};